export default "__VITE_ASSET__zFQHDfF8__"